import { useLocation } from 'react-router-dom';
import '@styles/components/appOperate.less';
import { setTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';

const AppOperate = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();

  // 购买页面不显示该组件
  if (pathname === '/buy') {
    return null;
  }

  return (
    <div className={'app-operate'}>
      <a href="tel:400-650-5128" className={'phone-consult'}>
        <img src={require('@images/common/phoneIcon2.png').default} alt="" />
        <span>电话咨询</span>
      </a>

      <a href="https://work.weixin.qq.com/kfid/kfcb8c045f81720f00b" className={'wx-consult'}>
        <img src={require('@images/common/weixinIcon.png').default} alt="" />
        <span>在线咨询</span>
      </a>

      <span className={'free'} onClick={() => dispatch(setTryOutDialog(true))}>
        申请试用
      </span>
    </div>
  );
};

export default AppOperate;
